import React, { Component } from 'react';
import { FormGroup, FormFeedback, Input, Button, Container } from 'reactstrap';
import {Link} from 'react-router-dom';
import {IconEye, ArrowRight, IconLock, IconEyeLock} from '../../assets/icons/svgIcon';
import {SvgAssets} from '../../assets/icons/iconSvg';
import { activarAcceso } from '../../store/sagas/authApi';
import { notificacion } from '../../utilitarios/util';
import c from '../../constants/Colors';
import Spinner from "../reusable/Loader";

export class IngresarContrasenia extends Component {
  static displayName = IngresarContrasenia.name;

  constructor (props) {
    super(props);

    this.state = {
      // password1: false,
      // password2: false,
      email: null,
      codigoVerificacion: null,
      password1: '',
      loading: false,
      password2: '',
      errorValidacion: null,
      hidePassword1: true,
      hidePassword2: true,
      icon1: 'icon-eye-close',
      icon2: 'icon-eye-close',
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      alertOptions: null
    };
    // this.togglePassword1 = this.togglePassword1.bind(this);
    // this.togglePassword2 = this.togglePassword2.bind(this);
  }

  // togglePassword1() {
  //   this.setState({password1: !this.state.password1})
  // }
  // togglePassword2() {
  //   this.setState({password2: !this.state.password2})
  // }

  load = async () => {
    this.setState({
      // codigoVerificacion:null,
      password1: '',
      loading: false,
      password2: '',
      errorValidacion: null
    });
  }

  changeIcon1() {
    this.setState(prevState => ({
      icon1: prevState.icon1 == 'icon-eye' ? 'icon-eye-close' : 'icon-eye',
      hidePassword1: !prevState.hidePassword1
    }))
  }
  changeIcon2() {
    this.setState(prevState => ({
      icon2: prevState.icon2 == 'icon-eye' ? 'icon-eye-close' : 'icon-eye',
      hidePassword2: !prevState.hidePassword2
    }))
  }

  ActivarAcceso = () => {
    this.setState({ errorValidacion: null, loading: true });
    if (this.state.password1 == null || this.state.password1 == "" || this.state.password2 == null || this.state.password2 == "") {
      // if (this.state.password1 || this.state.password2) {
      this.setState({ errorValidacion: "Debe ingresar el password", loading: false });
    } else if ((/^$|\s+/.test(this.state.password1))) {
      this.setState({ errorValidacion: "No debe tener espacios vacíos", loading: false });
    } else if (this.state.password1.length < 6 || this.state.password1.length > 20) {
      this.setState({ errorValidacion: "Debe ingresar entre 6 a 20 caracteres", loading: false });
    } else if (!(/[A-ZÑ]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe tener al menos una letra mayúscula", loading: false });
    } else if (!(/[a-zñ]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe tener al menos una letra minúscula", loading: false });
    } else if (!(/[0-9]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe contener al menos un número", loading: false });
    } else if (!(/[+×÷=/_€£()!¡¿*&^%$#@\\""':;,?.`~|<>°•○●□■♤♡◇♧₩¥¤▪︎☆》《-]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe tener al menos un símbolo", loading: false });
    } else if (this.state.password1 != this.state.password2) {
      this.setState({ errorValidacion: "Debe ingresar el mismo password", loading: false });
    } else {
      this.postActivarAcceso();
    }
  }
  postActivarAcceso = async () => {
    let CorreoElectronico = this.state.email;
    let CodigoVerificacion = this.state.codigoVerificacion;
    let Contrasenia = this.state.password1;
    this.setState({ loading: true });
    activarAcceso(CorreoElectronico, Contrasenia, CodigoVerificacion)
      .then(result => {
        this.setState({ loading: false });
        if (result.mo.type == "success") {
          this.setState({ loading: false }, async () => {
            // await this.notificacion("Bienvenido", "Su cuenta fue activada con éxito.");
            // navigation.navigate('Login')             

            await notificacion(
              "Bienvenido",
              "Su cuenta fue activada con éxito.",
              () => {
                // this.toggleModalAlert();
                this.props.history.push('/');
              },
            );
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        //console.log("postLogin ", error);
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Login", error.message ?? null);
        });
      });
  }
  // notificacion = async (alertTitulo = "", alertMensaje = "", alertOptions = null) => {
  //   this.setState({ alertTitulo, alertMensaje, alertOptions });
  //   this.toggleModalAlert();
  // }
  // toggleModalAlert = () => {
  //   this.setState(prevState => ({
  //     showAlert: !prevState.showAlert,
  //   }));
  // }
  setPassword1 = (value) => {
    this.setState({ password1: value, errorValidacion: null })
  }
  setPassword2 = (value) => {
    this.setState({ password2: value, errorValidacion: null })
  }
  checkParams() {
    const { state } = this.props.location;
    this.setState({ email: state.email, codigoVerificacion: state.codigoVerificacion });
  }
  componentDidMount() {
    this.load();
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render () {
  const { loading, password1, password2, errorValidacion, hidePassword1, icon1, hidePassword2, icon2 } = this.state;
  // const {password1, password2} = this.state;
    return (
      <Container className="py-5" id="mhw">
        <Spinner visible={loading} />
        <h4 className="text-center title-2 verde desktop"><SvgAssets className="mr-2" icon="icon-lock" fill={c.verde}/>Ingresa tu contraseña</h4>
        <div className="card card_container">
          <h4 className="text-center title-2 verde mobile"><IconLock className='icon-block' />Ingresa <br className="mobile"/> tu contraseña</h4>
          <form>
            <FormGroup className="icon">
              <Input className="verde" type={!hidePassword1? 'text' : 'password'} name="password" placeholder="Contraseña" value={password1} onChange={(e) => { let password1 = e.currentTarget.value; this.setPassword1(password1)}} />
              <Button color="link" className="btn-icon verde" onClick={() => this.changeIcon1()}>
                {!hidePassword1 ? <IconEye/> : <IconEyeLock/>}
              </Button>
            </FormGroup>
            <FormGroup className="icon">
              <Input className="verde" type={!hidePassword2? 'text' : 'password'} name="password" placeholder="Confirmar contraseña" value={password2} onChange={(e) => { let password2 = e.currentTarget.value; this.setPassword2(password2)}} />
              <Button color="link" className="btn-icon verde" onClick={() => this.changeIcon2()}>
                {!hidePassword2 ? <IconEye/> : <IconEyeLock/>}
              </Button>
              {errorValidacion ? <FormFeedback>{errorValidacion}</FormFeedback> : null}
            </FormGroup>
            <p className="paragraph-2 desktop_parrafo3" style={{ color: c.verdeClaro }}>Debe contener al menos una letra mayúscula, una minúscula, un número y un símbolo. Mínimo 6 y máximo 20 caracteres.</p>
          </form>
          <div className="text-center mt-5">
            {/* <Link to="/linea-negocio" style={{textDecoration:'none'}}> */}
            <button className={`btn-block red${(password1 != "" && password2 != "" ? "" : " disabled")}`}
            disabled={password1 == "" || password2 == ""}
            onClick={() => this.ActivarAcceso()}
            >
              siguiente<ArrowRight className='svg-right' />
            </button>
            {/* </Link> */}
          </div>
        </div>
      </Container>
    );
  }
}
